import { LinkExpirationSetting } from 'modules/domains/links';
import { linksArrayName, linksFormId } from 'modules/linkExpirationManagement/constants';
import {
  useDataQueryContext,
  useFieldArrayContext,
} from 'modules/linkExpirationManagement/contexts';
import { ModalAction } from 'modules/linkExpirationManagement/types';
import { useFormContext } from 'react-hook-form';
import { PAGE_SIZES, PaginationUpdateEvent } from 'ui/paginationFooter';
import { FullWidth } from 'ui/utility/fullWidth';
import { useModalContext } from 'utils/contexts/modal';
import { usePaginationContext } from 'utils/contexts/pagination';
import { ActionCell } from './ActionCell';
import { EffectiveDateCell } from './EffectiveDateCell';
import { LinkActionCell } from './LinkActionCell';
import { LocationCell } from './LocationCell';
import { ProjectCell } from './ProjectCell';
import { GRID_LAYOUT, StyledPaginationFooter, StyledTableRow } from './Table.styled';
import { TableBody } from './TableBody';
import { TableHeader } from './TableHeader';

export const Table = () => {
  const { watch } = useFormContext();
  const { currentPage, pageSize, setCurrentPage, setPageSize } = usePaginationContext();
  const { showModal } = useModalContext();
  const { effectiveDateOptions, isLoading } = useDataQueryContext();
  const { fields, onSubmitChangedFields, totalFieldsCount } = useFieldArrayContext();

  /** Copy current selection to all project links */
  const onClickAction = (setting: LinkExpirationSetting) => {
    showModal({
      action: ModalAction.COPY_ALL,
      payload: { setting },
    });
  };

  const handlePaginationUpdate = (paginationEvent: PaginationUpdateEvent) => {
    setCurrentPage(paginationEvent.page);
    setPageSize(paginationEvent.pageSize);
  };

  return (
    <FullWidth>
      <TableHeader />
      <TableBody
        currentLinksCount={fields.length}
        isLoading={isLoading}
        totalLinksCount={fields.length}
      >
        <form id={linksFormId} onSubmit={onSubmitChangedFields}>
          {fields.map((field) => {
            const { index, projectName, projectId } = field;
            const prefix = `${linksArrayName}.${index}`;
            const currentValues = watch(prefix);
            return (
              <StyledTableRow gridLayout={GRID_LAYOUT} key={field.id}>
                <ProjectCell projectName={projectName} projectId={projectId} />
                <LinkActionCell name={`${prefix}.linkAction`} />
                <LocationCell
                  name={`${prefix}.redirectLocation`}
                  linkAction={currentValues.linkAction}
                />
                <EffectiveDateCell
                  name={`${prefix}.effectiveDate`}
                  options={effectiveDateOptions}
                />
                <ActionCell onClick={() => onClickAction(currentValues)} />
              </StyledTableRow>
            );
          })}
        </form>
      </TableBody>
      {fields.length > 0 && (
        <StyledPaginationFooter
          currentPage={currentPage}
          itemsPerPage={pageSize}
          numItems={totalFieldsCount}
          pageSizes={PAGE_SIZES}
          onUpdate={handlePaginationUpdate}
        />
      )}
    </FullWidth>
  );
};
